export default __webpack_public_path__ + "static/media/Icon-Left_Arrow_Hot.426c6d6b.svg";